var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F1EFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2854 25.0783C22.2793 27.1103 23.9265 28.75 25.963 29.7347C26.112 29.8053 26.2768 29.8359 26.4413 29.8234C26.6057 29.811 26.764 29.756 26.9007 29.6637L29.8994 27.6642C30.032 27.5757 30.1846 27.5218 30.3433 27.5072C30.502 27.4926 30.6619 27.5179 30.8084 27.5806L36.4184 29.9849C36.6089 30.0659 36.768 30.2065 36.8717 30.3858C36.9754 30.565 37.018 30.7731 36.9931 30.9786C36.8158 32.3661 36.1388 33.6414 35.0889 34.5657C34.039 35.49 32.6883 35.9999 31.2895 36C26.9692 36 22.826 34.2838 19.7711 31.2289C16.7162 28.174 15 24.0308 15 19.7105C15.0001 18.3117 15.51 16.961 16.4343 15.9111C17.3586 14.8612 18.6339 14.1842 20.0214 14.0069C20.2269 13.982 20.435 14.0246 20.6142 14.1283C20.7934 14.232 20.9341 14.3911 21.0151 14.5816L23.4214 20.1965C23.4837 20.3417 23.5091 20.5001 23.4953 20.6575C23.4815 20.8149 23.429 20.9664 23.3425 21.0986L21.3498 24.1433C21.2592 24.2803 21.2055 24.4384 21.1942 24.6023C21.1829 24.7662 21.2143 24.9302 21.2854 25.0783V25.0783Z",
    stroke: "#4A3798",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.1e27bc0b6f9bd2a9d073344a560c4e58.svg";
export { ForwardRef as ReactComponent };